/* eslint-disable @typescript-eslint/no-require-imports */
import type React from "react";

import CustomPlatform from "$src/core/utils/platform/platform";

import type { ToggleProps } from "./types";

export default CustomPlatform.select<() => React.FC<ToggleProps>>({
  tv: () => require("./Toggle.tv").default,
  default: () => require("./Toggle").default,
})();
